// extracted by mini-css-extract-plugin
export var arrowIcon = "TeamCanJoin-module--arrowIcon--lJsiH";
export var headerSection = "TeamCanJoin-module--headerSection--+mAOM";
export var teamCanJoinWrapper = "TeamCanJoin-module--teamCanJoinWrapper--JR0-g";
export var teamCard = "TeamCanJoin-module--teamCard--jJjTl";
export var teamDescription = "TeamCanJoin-module--teamDescription--gPRME";
export var teamHeader = "TeamCanJoin-module--teamHeader--timOO";
export var teamTitle = "TeamCanJoin-module--teamTitle--2s4UC";
export var title = "TeamCanJoin-module--title--WdUbM";